/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as braindateTypes from 'src/shared/domain/braindate/action/braindateActionTypes';

/*
|------------------------------------------------------------------------------
 | Initial State
 |------------------------------------------------------------------------------
 */

const initialState = {
  isBraindateNotFound: false,
  respondToBraindate: {
    id: null,
    isShown: null,
  },
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const setBraindateNotFoundError = (state: Object) => ({
  ...state,
  isBraindateNotFound: true,
});

const setRespondToBraindate = (
  state: Object,
  { braindateId }: { braindateId: number },
) => ({
  ...state,
  respondToBraindate: {
    id: braindateId,
    isShown: true,
  },
});
const hideRespondToBraindate = (state: Object) => ({
  ...state,
  respondToBraindate: {
    ...state.respondToBraindate,
    isShown: false,
  },
});

/*
 |------------------------------------------------------------------------------
 | Reducer
 |------------------------------------------------------------------------------
 */

export default createReducer(initialState, {
  [braindateTypes.FETCH_BRAINDATE_FAILURE]: setBraindateNotFoundError,
  [braindateTypes.SET_RESPOND_TO_BRAINDATE]: setRespondToBraindate,
  [braindateTypes.HIDE_RESPOND_TO_BRAINDATE]: hideRespondToBraindate,
});
